import React from 'react';

export function Header() {

    return (
        <div className="flex items-center justify-between p-4 bg-white border-b border-slate-200 shadow-sm">
            {/* Left Side: Logo and Title */}
            <div className="flex items-center gap-3">
                <img src={'/assets/CA_Logo_32x32.png'} alt="Cambridge Associates" className="w-10 h-10 object-contain"/>
                <h2 className="font-semibold text-slate-800">CAi Box Integration</h2>
            </div>

        </div>
    );
}